import Exception from './Exception'

export default class RuntimeException extends Exception { }
